<template>
  <div
    id="top"
    ref="top"
    @mouseleave="mouseleaveTop"
    @mouseenter="mouseenterTop"
  >
    <div class="top01">
      <div class="top_div" @click="$router.push('/')">
        <img
          id="logoId1"
          style="display: block"
          title="万佶物流平台"
          src="../assets/images/logo.png"
          alt="万佶物流平台"
        />
        <img
          id="logoId2"
          title="万佶物流平台"
          src="../assets/images/logoActive.png"
          alt="万佶物流平台"
        />
      </div>
      <ul class="top_ul">
        <li
          @click="$router.push('/')"
          :class="
            $route.path == '/home' ||
            $route.path == '/' ||
            $route.path == '/index' ||
            $route.path == '/caseDetail'
              ? 'active'
              : ''
          "
        >
          <p class="li_p">首页</p>
        </li>
        <li
          @mouseleave="mouseleave2"
          @mouseenter="mouseenter2"
          :class="
            $route.path == '/aboutSketch' ||
            $route.path == '/aboutCulture' ||
            $route.path == '/aboutDuty' ||
            $route.path == '/aboutSpeak'
              ? 'active'
              : ''
          "
        >
          <p class="li_p">品牌</p>
          <ul :style="style2" class="navitionTwo">
            <li
              @click="$router.push({ path: '/aboutSketch' })"
              :class="$route.path == '/aboutSketch' ? 'active1' : ''"
            >
              企业概况
            </li>
            <li
              @click="$router.push({ path: '/aboutCulture' })"
              :class="$route.path == '/aboutCulture' ? 'active1' : ''"
            >
              企业文化
            </li>
            <li
              @click="$router.push({ path: '/aboutDuty' })"
              :class="$route.path == '/aboutDuty' ? 'active1' : ''"
            >
              企业责任
            </li>
            <li
              @click="$router.push({ path: '/aboutSpeak' })"
              :class="$route.path == '/aboutSpeak' ? 'active1' : ''"
            >
              CEO致辞
            </li>
          </ul>
        </li>
        <li
          @mouseleave="mouseleave6"
          @mouseenter="mouseenter6"
          @click="$router.push('/ecology')"
          :class="
            $route.path == '/ecology' ||
            $route.path == '/ecologyInfor' ||
            $route.path == '/ecologyPark' ||
            $route.path == '/ecologyDetail' ||
            $route.path == '/ecologyAbout'
              ? 'active'
              : ''
          "
        >
          <p class="li_p">生态</p>
          <ul :style="style6" class="navitionTwo" style="left: -41px">
            <li
              @click.stop="$router.push('/ecologyAbout')"
              :class="$route.fullPath == '/ecologyAbout' ? 'active1' : ''"
            >
              第三方物流服务
            </li>
            <li @click.stop="blankOpen">网络货运</li>
            <li
              @click.stop="$router.push('/ecologyPark')"
              :class="$route.fullPath == '/ecologyPark' ? 'active1' : ''"
            >
              智慧物流产业园
            </li>
            <li
              @click.stop="$router.push('/ecologydata')"
              :class="$route.fullPath == '/ecologydata' ? 'active1' : ''"
            >
              物流大数据
            </li>
            <li
              @click.stop="$router.push('/ecologyInfor')"
              :class="$route.fullPath == '/ecologyInfor' ? 'active1' : ''"
            >
              物流公共信息平台
            </li>
          </ul>
        </li>
        <li
          @mouseleave="mouseleave5"
          @mouseenter="mouseenter5"
          :class="
            $route.path == '/wanjiNews' || $route.path == '/industryNews'
              ? 'active'
              : ''
          "
        >
          <p class="li_p">资讯</p>
          <ul :style="style5" class="navitionTwo" style="left: -41px">
            <li
              @click="$router.push('/wanjiNews')"
              :class="$route.path == '/wanjiNews' ? 'active1' : ''"
            >
              万佶动态
            </li>
            <li
              @click="$router.push('/industryNews')"
              :class="$route.fullPath == '/industryNews' ? 'active1' : ''"
            >
              行业动态
            </li>
          </ul>
        </li>
        <li
          @mouseleave="mouseleave4"
          @mouseenter="mouseenter4"
          :class="
            $route.path == '/joinPeople' ||
            $route.path == '/joinPlatform' ||
            $route.path == '/joinPark' ||
            $route.path == '/joinIndustry'
              ? 'active'
              : ''
          "
        >
          <p class="li_p">招商加盟</p>
          <ul :style="style4" class="navitionTwo" style="left: -23px">
            <li
              @click="$router.push('/joinPeople')"
              :class="$route.path == '/joinPeople' ? 'active1' : ''"
            >
              合伙人
            </li>
            <li
              @click="$router.push('/joinPlatform')"
              :class="$route.fullPath == '/joinPlatform' ? 'active1' : ''"
            >
              产业数字化
            </li>
            <li
              @click="$router.push('/joinPark')"
              :class="$route.fullPath == '/joinPark' ? 'active1' : ''"
            >
              智慧物流园区
            </li>
            <li
              @click="$router.push('/joinIndustry')"
              :class="$route.fullPath == '/joinIndustry' ? 'active1' : ''"
            >
              数字物流产业园
            </li>
          </ul>
        </li>
        <li
          @mouseleave="mouseleave3"
          @mouseenter="mouseenter3"
          :class="
            $route.path == '/joinUs' ||
            $route.path == '/contact' ||
            $route.path == '/personnel'
              ? 'active'
              : ''
          "
        >
          <p class="li_p">联系</p>
          <ul :style="style3" class="navitionTwo" style="left: -35px">
            <li
              @click="$router.push('/contact')"
              :class="$route.path == '/contact' ? 'active1' : ''"
            >
              联系我们
            </li>
            <li
              @click="$router.push('/joinUs')"
              :class="$route.fullPath == '/joinUs' ? 'active1' : ''"
            >
              人才招聘
            </li>
          </ul>
        </li>
        <li @click="searchShow = true" class="last">
          <img
            id="icon_seach1"
            style="display: block"
            src="../assets/images/icon_seach.png"
            alt=""
          />
          <img
            id="icon_seach2"
            style="display: none"
            src="../assets/images/icon_seachActive.png"
            alt=""
          />
        </li>
      </ul>
    </div>
    <el-dialog
      :visible.sync="searchShow"
      append-to-body
      custom-class="searchSty"
      width="600px"
      top="40vh"
    >
      <el-input placeholder="请输入关键字搜索产品和新闻" v-model="searchText">
      </el-input>
      <i
        style="
          position: absolute;
          right: 15px;
          top: 2px;
          transform: scale(1.35);
          cursor: pointer;
        "
        class="el-icon-search el-input__icon"
        @click="searchIconClick"
      >
      </i>
    </el-dialog>
  </div>
</template>
<script>
window.onscroll = function () {
  var top1 = document.getElementById("top");
  var logoId1 = document.getElementById("logoId1");
  var logoId2 = document.getElementById("logoId2");
  var icon_seach1 = document.getElementById("icon_seach1");
  var icon_seach2 = document.getElementById("icon_seach2");
  var scrollTop = document.documentElement.scrollTop;
  // console.log('Top',scrollTop);
  if (scrollTop < 200) {
    top1.style.backgroundColor = "transparent";
    logoId1.style.display = "block";
    logoId2.style.display = "none";
    icon_seach1.style.display = "block";
    icon_seach2.style.display = "none";
    top1.style.color = "#fff";
  } else {
    top1.style.backgroundColor = "#fff";
    top1.style.color = "#000";
    logoId1.style.display = "none";
    logoId2.style.display = "block";
    icon_seach1.style.display = "none";
    icon_seach2.style.display = "block";
  }
};
export default {
  name: "top",
  data() {
    return {
      style2: {
        display: "none",
      },
      style3: {
        display: "none",
      },
      style4: {
        display: "none",
      },
      style5: {
        display: "none",
      },
      style6: {
        display: "none",
      },
      searchShow: false,
      searchText: "",
    };
  },
  watch: {
    searchShow: {
      handler(val) {
        if (val == false) {
          this.searchText = "";
        }
      },
    },
  },
  methods: {
    blankOpen() {
      window.open("https://www.ywl56.com", "_target");
    },
    mouseenter2() {
      this.style2.display = "block";
    },
    mouseleave2() {
      this.style2.display = "none";
    },
    mouseenter3() {
      this.style3.display = "block";
    },
    mouseleave3() {
      this.style3.display = "none";
    },
    mouseenter4() {
      this.style4.display = "block";
    },
    mouseleave4() {
      this.style4.display = "none";
    },
    mouseenter5() {
      this.style5.display = "block";
    },
    mouseleave5() {
      this.style5.display = "none";
    },
    mouseenter6() {
      this.style6.display = "block";
    },
    mouseleave6() {
      this.style6.display = "none";
    },
    mouseenterTop() {
      if (logoId1.style.display == "block") {
        logoId2.style.display = "block";
        logoId1.style.display = "none";
        icon_seach2.style.display = "block";
        icon_seach1.style.display = "none";
      }
    },
    mouseleaveTop() {
      if (
        logoId2.style.display == "block" &&
        document.documentElement.scrollTop < 200
      ) {
        logoId2.style.display = "none";
        logoId1.style.display = "block";
        icon_seach2.style.display = "none";
        icon_seach1.style.display = "block";
      }
    },
    searchIconClick() {
      this.searchShow = false;
    },
  },
};
</script>

<style scoped lang="less">
.top_ul {
  .last {
    display: flex;
    align-items: center;
    img {
      width: 34px;
      height: 34px;
    }
  }
}
#top {
  color: #fff;
  width: 100%;
  transition: all 0.4s linear 0s;
  .top01 {
    width: 1200px;
    margin: auto;
    height: 80px;
    position: relative;
  }
  .top_div {
    cursor: pointer;
    padding-top: 15px;
    img {
      margin-top: 8px;
      display: none;
      width: 166px;
      height: 42px;
    }
  }
  .top_ul {
    position: absolute;
    right: -31px;
    top: 15px;
    display: flex;
    height: 58px;
    z-index: 9;
    > li {
      font-size: 17px;
      cursor: pointer;
      margin: 0px 23px;
      box-sizing: border-box;
      position: relative;
      font-weight: 500;
      p {
        padding: 15px 20px;
        height: 45px;
      }
      &:hover {
        border-bottom: 2px solid #0070df;
        .li_p {
          color: #0070df !important;
          font-weight: bold !important;
        }
      }
    }
    li:nth-last-of-type(1) {
      &:hover {
        border-bottom: none;
      }
    }
    .navitionTwo {
      transition: all 0.3s linear 0s;
      position: absolute;
      top: 56px;
      color: #333;
      background: rgba(255, 255, 255, 1);
      width: 152px;
      left: -39px;
      text-align: center;
      font-weight: normal;
      padding-top: 7px;
      animation: optDowm 0.3s ease-in;
      z-index: -2;
      > li {
        padding: 10px 0px;
        border-bottom: 1px solid rgb(216, 216, 216);
        &:hover {
          color: #0070df !important;
          font-weight: bold !important;
        }
      }
    }
    .navitionTwo2 {
      transition: all 0.3s linear 0s;
      position: absolute;
      top: 63px;
      background: #fff;
      width: 110px;
      left: -3px;
      text-align: center;
      color: #333;
      padding-top: 7px;
      animation: optDowm 0.3s ease-in;
      > li {
        padding: 10px 0px;
        font-weight: normal;
        &:hover {
          color: #0070df !important;
          font-weight: bold !important;
        }
        > a {
          color: #fff;
        }
      }
    }
  }
  .active {
    color: #0070df !important;
    font-weight: bold !important;
    border-bottom: 2px solid #0070df;
    .li_p {
      color: #0070df !important;
      font-weight: bold !important;
    }
  }
  .active1 {
    color: #0070df !important;
    font-weight: bold !important;
  }
}
#top:hover {
  background: rgba(255, 255, 255, 1) !important;
  color: #222222 !important;
}
@keyframes optDowm {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  50% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes optLeft {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  50% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
<style>
.searchSty > .el-dialog__body {
  padding: 0px !important;
  border-radius: 25px !important;
}
.searchSty > .el-dialog__header {
  display: none !important;
}
.el-dialog__wrapper .searchSty {
  background: transparent !important;
}
.searchSty .el-input {
  border: none;
}
.searchSty .el-input input {
  border-radius: 25px !important;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/top.vue